'use client';

import { c as _c } from "react/compiler-runtime";
import type { IntimacaoSentencaDados } from '../../types/encerramento.types';
import { formatarDataExtenso } from '../../utils/formatarEncerramento';
import { BlocoPrazoDocumento } from './BlocoPrazoDocumento';
import { MolduraDocumento } from './MolduraDocumento';
interface IntimacaoSentencaDocumentoProps {
  readonly dados: IntimacaoSentencaDados;
  readonly onVoltar?: () => void;
  readonly onBaixarPdf?: () => void;
}
export function IntimacaoSentencaDocumento(t0) {
  const $ = _c(24);
  const {
    dados,
    onVoltar,
    onBaixarPdf
  } = t0;
  const temIntimados = dados.intimados.length > 0;
  const t1 = dados.camara;
  const t2 = dados.codigoAutenticidade;
  const t3 = dados.numeroProcesso;
  const t4 = dados.processoEncerradoEm;
  let t5;
  if ($[0] !== dados.emitidoEm) {
    t5 = formatarDataExtenso(dados.emitidoEm);
    $[0] = dados.emitidoEm;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const t6 = `Emitida em ${t5}`;
  let t7;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <h2 className="mb-1.5 text-xs text-neutral-500">Intimados</h2>;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  let t8;
  if ($[3] !== dados.intimados || $[4] !== temIntimados) {
    t8 = <section>{t7}{temIntimados ? <ul className="text-sm leading-relaxed text-neutral-900">{dados.intimados.map(_temp)}</ul> : <p className="text-sm text-neutral-600">Nenhuma parte intimada registrada. A intimação não produz efeito sem destinatário.</p>}</section>;
    $[3] = dados.intimados;
    $[4] = temIntimados;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== dados.sentencaProferidaEm) {
    t9 = formatarDataExtenso(dados.sentencaProferidaEm);
    $[6] = dados.sentencaProferidaEm;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== t9) {
    t10 = <p className="text-sm leading-relaxed text-neutral-900">Fica V.Sa. intimado de que foi proferida sentença arbitral neste processo em{" "}{t9}, já disponível para consulta e download na plataforma.</p>;
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== dados.prazo) {
    t11 = <BlocoPrazoDocumento prazo={dados.prazo} variante="destaque" />;
    $[10] = dados.prazo;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <p className="text-sm leading-relaxed text-neutral-600">Decorrido o prazo sem pedido de esclarecimento, será certificado o trânsito em julgado e o processo será encerrado.</p>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== dados.camara || $[14] !== dados.codigoAutenticidade || $[15] !== dados.numeroProcesso || $[16] !== dados.processoEncerradoEm || $[17] !== onBaixarPdf || $[18] !== onVoltar || $[19] !== t10 || $[20] !== t11 || $[21] !== t6 || $[22] !== t8) {
    t13 = <MolduraDocumento camara={t1} codigoAutenticidade={t2} icone="gavel" legendaCamara="Secretaria arbitral" numeroProcesso={t3} onBaixarPdf={onBaixarPdf} onVoltar={onVoltar} processoEncerradoEm={t4} subtitulo={t6} titulo={"Intima\xE7\xE3o de senten\xE7a"}>{t8}{t10}{t11}{t12}</MolduraDocumento>;
    $[13] = dados.camara;
    $[14] = dados.codigoAutenticidade;
    $[15] = dados.numeroProcesso;
    $[16] = dados.processoEncerradoEm;
    $[17] = onBaixarPdf;
    $[18] = onVoltar;
    $[19] = t10;
    $[20] = t11;
    $[21] = t6;
    $[22] = t8;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
}
function _temp(parte) {
  return <li key={parte.parteId}>{parte.nome} — {parte.papel}</li>;
}